"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable id-length */
exports.default = {
    a: {},
    abbr: {},
    address: {},
    area: {},
    article: {},
    aside: {},
    audio: {},
    b: {},
    base: {
        reserved: true
    },
    bdi: {},
    bdo: {},
    big: {},
    blockquote: {},
    body: {},
    br: {},
    button: {},
    canvas: {},
    caption: {},
    cite: {},
    code: {},
    col: {
        reserved: true
    },
    colgroup: {
        reserved: true
    },
    data: {},
    datalist: {},
    dd: {},
    del: {},
    details: {},
    dfn: {},
    dialog: {},
    div: {},
    dl: {},
    dt: {},
    em: {},
    embed: {},
    fieldset: {},
    figcaption: {},
    figure: {},
    footer: {},
    form: {},
    h1: {},
    h2: {},
    h3: {},
    h4: {},
    h5: {},
    h6: {},
    head: {
        reserved: true
    },
    header: {},
    hgroup: {},
    hr: {},
    html: {
        reserved: true
    },
    i: {},
    iframe: {},
    img: {},
    input: {},
    ins: {},
    kbd: {},
    keygen: {},
    label: {},
    legend: {},
    li: {},
    link: {
        reserved: true
    },
    main: {},
    map: {},
    mark: {},
    menu: {},
    menuitem: {},
    meta: {
        reserved: true
    },
    meter: {},
    nav: {},
    noscript: {
        reserved: true
    },
    object: {},
    ol: {},
    optgroup: {},
    option: {},
    output: {},
    p: {},
    param: {
        reserved: true
    },
    path: {},
    picture: {
        reserved: true
    },
    pre: {},
    progress: {},
    q: {},
    rp: {},
    rt: {},
    ruby: {},
    s: {},
    samp: {},
    script: {
        reserved: true
    },
    section: {},
    select: {},
    small: {},
    source: {
        reserved: true
    },
    span: {},
    strong: {},
    style: {
        reserved: true
    },
    sub: {},
    summary: {},
    sup: {},
    svg: {},
    table: {},
    tbody: {},
    td: {},
    textarea: {},
    tfoot: {},
    th: {},
    thead: {},
    time: {},
    title: {
        reserved: true
    },
    tr: {},
    track: {
        reserved: true
    },
    u: {},
    ul: {},
    var: {},
    video: {},
    wbr: {}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-a11y/lib/util/DOM.js
// module id = 1596
// module chunks = 95 96